import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { JwtHelperService } from '@auth0/angular-jwt';
import { RouteConfig } from 'app/route.config';
import { HttpClientService } from './http-client.service';
import { LoginUserModel } from 'app/main/pages/authentication/login/login-model';
import { Observable, of } from 'rxjs';

@Injectable()
export class AuthService {
    constructor(private http: Http,
        private routeConfig: RouteConfig,
        public jwtHelper: JwtHelperService,
        private _httpClient: HttpClientService) { }

    loggedIn() {
        return !this.jwtHelper.isTokenExpired();
    }

    login(credentials: LoginUserModel) {
        return this._httpClient.post('/Account/Login', credentials).toPromise();
    }

    logout() {
        // To log out, we just need to remove auth_token & role        
        return this._httpClient.authPost('/Account/logout', null).toPromise();
    }

    checkAuthToken() {
        return this.http.get(this.routeConfig.Url('/Values')).toPromise();
    }

    // Check the authentication status
    check(): Observable<boolean> {
        // Check if the user is logged in
        if (this.loggedIn()) {
            return of(true);
        }

        // Check the access token availability
        if (!this.loggedIn()) {
            return of(false);
        }

        // If the access token exists and it didn't expire, sign in using it
        return of(true);
    }
}
